import { inject, Injectable } from '@angular/core';
import { ESLRepository } from '../repository/esl-repository';

type ESLScenarioType = 'inventur' | 'abcanalyse';

@Injectable({ providedIn: 'root' })
export class ESLService {
  private readonly repository = inject(ESLRepository);

  async checkIfEslExists(itemId: number): Promise<any> {
    return await this.repository.checkIfEslExists(itemId);
  }

  async flashEsl(productIds?: number[], storageLocationId?: number): Promise<any> {
    return await this.repository.flashEsl({
      productIds,
      storagelocationId: storageLocationId,
    });
  }

  async switchEslScenario(
    type: ESLScenarioType,
    productIds?: number[],
    storageLocationId?: number
  ): Promise<any> {
    return await this.repository.switchEslScenario(type, {
      productIds,
      storagelocationId: storageLocationId,
    });
  }
}
